<div class="layout-footer clearfix">
    <a href="http://softoursistemas.com/">
        <img src="assets/layout/images/footer/logoSoftour.png" alt="softour" height="30" />
    </a>
    <!-- <div class="layout-footer-icons">
        <a href="#twitter" class="icon-link"><i class="pi pi-twitter icon"></i></a>
        <a href="#facebook" class="icon-link"><i class="pi pi-facebook icon"></i></a>
        <a href="#github" class="icon-link"><i class="pi pi-github icon"></i></a>
    </div> -->
</div>